// Prismjs
// https://prismjs.com/#basic-usage
import Prism from 'prismjs';

// Prism Load Languages
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-markup';

// Prism Plugins
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';

// Prism Styles
import 'prismjs/themes/prism-okaidia.css'; // or 'prism.css' for default
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

// Prism Init
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('pre code').forEach((codeBlock) => {
        const pre = codeBlock.parentElement;
        if (!pre.classList.contains('line-numbers')) {
            pre.classList.add('line-numbers');
        }
    });

    Prism.highlightAll();
});
